import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { HomePage } from "@/routes/public/HomePage";
import { PostsIndexPage } from "@/routes/public/PostsIndexPage";
import { PostPage } from "@/routes/public/PostPage";
import { CalendarPage } from "@/routes/public/CalendarPage";
import { EventPage } from "@/routes/public/EventPage";
import { StaticPage } from "@/routes/public/StaticPage";
import { SearchPage } from "@/routes/public/SearchPage";
import { ContactPage } from "@/routes/public/ContactPage";
import { ServicesPage } from "@/routes/public/ServicesPage";
const AdminApp = lazy(() => import("@/routes/admin/AdminApp"));

export function App() {
  return (
    <Routes>
      <Route path="/" element={<PublicLayout />}>
        <Route index element={<HomePage />} />
        <Route path="aktuelles" element={<PostsIndexPage />} />
        <Route path="aktuelles/:slug" element={<PostPage />} />
        <Route path="kalender" element={<CalendarPage />} />
        <Route path="kalender/:slug" element={<EventPage />} />
        <Route path="suche" element={<SearchPage />} />
        <Route path="kontakt" element={<ContactPage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="*" element={<StaticPageOrNotFound />} />
      </Route>
      <Route
        path="/admin/*"
        element={
          <Suspense fallback={<div className="p-8">Lade Admin...</div>}>
            <AdminApp />
          </Suspense>
        }
      />
      <Route path="/de" element={<Navigate to="/" replace />} />
      <Route path="/en/*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function StaticPageOrNotFound() {
  // For any unknown path under /, attempt to resolve as a static page;
  // the StaticPage component handles its own 404 fallback.
  return <StaticPage />;
}
